export const Endpoint = () => `/api/v3/agent/deleteInactive/`;
export const Csrf = () => `/api/v3/agent/token/`;
export declare const QueryKey: never;
export type Payload = {
    days: number;
};
export type Response = void;
